import { Reveal } from "./Reveal";
import { ISIC_ARGS, ISIC_STATS } from "../../data/smartContent";

export const SmartISIC = () => (
  <section id="isic" data-testid="section-isic" className="scroll-mt-20 bg-ink py-14 lg:py-20">
    <div className="mx-auto max-w-7xl px-5 lg:px-10">
      <div className="max-w-3xl">
        <Reveal>
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-isic">
            International Student Identity Card
          </p>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="mt-4 font-serif text-3xl sm:text-4xl font-semibold leading-[1.15] text-white">
            Ce este International Student Identity Card
          </h2>
        </Reveal>
        <Reveal delay={0.16}>
          <p className="mt-5 text-lg leading-relaxed text-white/70">
            Oferită gratuit în cadrul acestui proiect, prin intermediul pachetului BRD-ISIC.
          </p>
        </Reveal>
      </div>

      <div className="mt-12 grid gap-x-12 gap-y-10 lg:grid-cols-3">
        {ISIC_ARGS.map((arg, i) => (
          <Reveal key={arg.title} delay={i * 0.08}>
            <div data-testid={`isic-arg-${i}`} className="border-t border-white/15 pt-6">
              <span className="font-serif text-lg font-semibold text-isic">0{i + 1}</span>
              <h3 className="mt-4 font-serif text-xl font-semibold text-white leading-snug">{arg.title}</h3>
              <p className="mt-4 text-[15px] leading-relaxed text-white/70">{arg.text}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1}>
        <dl className="mt-14 grid grid-cols-1 sm:grid-cols-3 gap-10 border-t border-white/15 pt-10">
          {ISIC_STATS.map((stat) => (
            <div key={stat.label} className="text-center sm:text-left">
              <dt className="font-serif text-5xl font-semibold text-isic">{stat.value}</dt>
              <dd className="mt-2 text-sm text-white/60">{stat.label}</dd>
            </div>
          ))}
        </dl>
      </Reveal>
    </div>
  </section>
);
